// Photographs and screenshots the pages show once they exist. A slot set to
// null renders nothing at all — no placeholder ever reaches a visitor.
//
// Files go in public/coilmind/photos/. Sizes are what each slot is drawn at,
// doubled for high-density screens; anything larger is wasted bytes.

export const PHOTOS = {
  // Portrait beside "Who's behind this". 4:5, 800 × 1000 px, JPG.
  // e.g. { src: '/coilmind/photos/cirill.jpg', alt: 'Cirill at his desk' }
  founder: null,
  // Wide shot under the founder block: on site, at a cabinet, or the desk with
  // TIA Portal open. 3:2, 1800 × 1200 px, JPG.
  workbench: null,
};

// Real TIA Portal screenshots for the feature tabs that have no clip. Keyed by
// FEATURES[].name in content.js. 16:10, 1600 × 1000 px, PNG (crisp UI text).
// Crop to the part that matters — the panel is about 640 px wide.
export const SCREENSHOTS = {
  Analysis: null,
  Documentation: null,
  Cloning: null,
  Generator: null,
  'Legacy STL': null,
  Translation: null,
  Templater: null,
  'WinCC Unified': null,
};
